/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Error_Route_TitleInputs */

const en_ui_error_route_title = /** @type {(inputs: Ui_Error_Route_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This page tripped up`)
};

const de_ui_error_route_title = /** @type {(inputs: Ui_Error_Route_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Seite ist gestolpert`)
};

/**
* | output |
* | --- |
* | "This page tripped up" |
*
* @param {Ui_Error_Route_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_error_route_title = /** @type {((inputs?: Ui_Error_Route_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Error_Route_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_error_route_title(inputs)
	return de_ui_error_route_title(inputs)
});